import { Trans } from '@lingui/macro'

import * as React from 'react'

import { useFormContext, useFormState } from '~shared/segments/Form'
import { InputLabel } from '~ui/components/formElements/accessories/InputLabel'
import { Grid } from '~ui/components/layout/Box'

import { TOrderForm } from '../../../contexts/FormProvider'
import { usePromoCodesCtx } from '../contexts/PromoCodeProvider'
import { AppliedPromoCode } from './AppliedPromoCode'

type TProps = NoChildren

/**
 * Renders all promo codes that are currently applied to the order.
 */
export const AppliedPromoCodes: React.FC<TProps> = () => {
  const { control } = useFormContext<TOrderForm>()
  const { isSubmitting } = useFormState({ control })
  const { promoCodes, removePromoCode } = usePromoCodesCtx()

  if (promoCodes.length === 0) {
    return null
  }

  // promoCode does not have anything unique if it would be applied multiple times
  // (no one uses it but we do support it) so the index has to be used as a key
  return (
    <Grid>
      <InputLabel>
        <Trans>Applied promo codes</Trans>
      </InputLabel>
      <Grid rowGap={`small`}>
        {promoCodes.map((promoCode, index) => (
          <AppliedPromoCode
            key={index}
            promoCode={promoCode}
            isDisabled={isSubmitting}
            onRemove={removePromoCode}
          />
        ))}
      </Grid>
    </Grid>
  )
}
